import { render, staticRenderFns } from "./mv-update-status.vue?vue&type=template&id=9bdf73c4&scoped=true"
import script from "./mv-update-status.vue?vue&type=script&lang=js"
export * from "./mv-update-status.vue?vue&type=script&lang=js"
import style0 from "./mv-update-status.vue?vue&type=style&index=0&id=9bdf73c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bdf73c4",
  null
  
)

export default component.exports